import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IGameAssignmentContext,
	GameAssignmentContext,
} from '../../../../../gameAssignmentState/gameAssignmentContext';
import SelectedItemForBreadcrumbs from 'components/SelectedItem/SelectedItemForBreadcrumbs';
import style from './RestaurantCrumb.module.scss';

const RestaurantCrumb: React.FC = () => {
	const { setIDsSelectedRestaurants, IDsSelectedRestaurants, restaurants } =
		useContext<IGameAssignmentContext>(GameAssignmentContext);

	const deleteRestaurant = (restaurantID: string) => {
		const copyIDsSelectedRestaurants = { ...IDsSelectedRestaurants };
		delete copyIDsSelectedRestaurants[restaurantID];
		setIDsSelectedRestaurants(copyIDsSelectedRestaurants, true);
	};

	return (
		<div className={style.container} data-test="RestaurantCrumb">
			<div className={style.scrollWrapper}>
				<Text
					className={style.crumbName}
					translationNameSpace="listing"
					translationKey="restaurantsLabel"
					size="s"
					weight="bold"
				/>
				{restaurants.map((customer, i) => {
					const hasSelectedRestaurants = customer.restaurants.find(
						(el) => el.restaurantId in IDsSelectedRestaurants,
					);

					return (
						<div key={customer.customerId} data-test={`item-${i}`}>
							{hasSelectedRestaurants && (
								<Text
									className={style.sectionName}
									translationKey={customer.customerName}
									size="xs"
									withTooltip={true}
								/>
							)}
							<div className={style.selectedItemWrapper}>
								{customer.restaurants.map((restaurant) => {
									if (restaurant.restaurantId in IDsSelectedRestaurants) {
										return (
											<SelectedItemForBreadcrumbs
												key={restaurant.restaurantId}
												label={restaurant.address || ''}
												onDelete={() => deleteRestaurant(restaurant.restaurantId)}
											/>
										);
									}
								})}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default RestaurantCrumb;
